import { GridLegacy } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { useFormContext } from "react-hook-form";

function AddDiscountProduct() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"freeProducts_JSON" + menukaartVestigingId}
              multiple
              name={"freeProducts_JSON"}
              tDefault={"Voucherproduct (in cash desk / on ticket)"}
              tKey={"voucherDefs.form.algemeen.label.voucherProduct"}
            />

            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"onlyifProductsInBasket_JSON" + menukaartVestigingId}
              multiple
              name={"onlyifProductsInBasket_JSON"}
              tDefault={"Only allow discount when these products are in Shopping Basket"}
              tKey={"voucherDefs.form.algemeen.label.onlyifProduct"}
            />

            <FormSwitchTC
              name={"allowOnEveryOnlyifProduct"}
              tDefault={"allowOnEveryOnlyifProduct"}
              tKey={"voucherDefs.form.algemeen.label.allowOnEveryOnlyifProduct"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default AddDiscountProduct;
